import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
const socialMedia = [
      {
        name: "Facebook",
        link: "https://www.facebook.com/cristhyan.calderon/",
        icon: <FacebookIcon />
      },
      {
        name: "Instagram",
        link: "https://www.instagram.com/cristhyan93/",
        icon: <InstagramIcon />
      },
      {
        name: "Youtube",
        link: "https://www.youtube.com/@nayhtsirc",
        icon: <YouTubeIcon />
      },
      {
        name: "LinkedIn",
        link: "https://www.linkedin.com/in/criscalderon/",
        icon: <LinkedInIcon />
      }
    ];

export default socialMedia